/* Maßfeld auf der Produktseite (snippets/cc-massfeld.liquid), live seit 15.09.2026.
 *
 * Formel wie assets/config-product.js (Klassik Matt) und assets/cc-funnel-danke.js:
 *   raw = BASE + AREA * flaeche^EXP + HCOEFF*H + WCOEFF*W + Stufe ; preis = round(raw) + 0.90
 *   Stufe = Zuschlag je m Breite, wenn die Höhe über der Materialstufe liegt
 *   sale  = preis * (100 - Rabatt) / 100, nur solange die Aktion läuft
 * Alle Formelwerte kommen von der echten Konfigurator-Seite des Motivs. Geholt wird erst,
 * wenn jemand ein Feld antippt; bis dahin steht der serverseitig gerenderte Startpreis.
 * Scheitert der Abruf, bleibt der Preis ausgegraut (lieber keiner als ein falscher).
 *
 * Seit 15.10.2026 (Usertest danario.fr): Das Maß geht an den Konfigurator über. Der merkt sich
 * seine Maße in sessionStorage 'appState' ([{height, width}, ...]); das Maßfeld schreibt dort
 * hinein und liest beim Laden daraus. Mehrere Stücke aus dem Konfigurator bleiben unangetastet.
 * Während des Tippens („5" auf dem Weg zu „50") keine Warnung, erst nach 2 s Pause oder beim
 * Verlassen des Feldes.
 */
(function () {
  var box = document.querySelector('[data-cc-massfeld]');
  if (!box) return;

  var hIn = box.querySelector('[data-cc-mf-h]');
  var wIn = box.querySelector('[data-cc-mf-w]');
  var jetztEl = box.querySelector('[data-cc-mf-jetzt]');
  var normalEl = box.querySelector('[data-cc-mf-normal]');
  var fehlerEl = box.querySelector('[data-cc-mf-fehler]');
  var sale = box.getAttribute('data-sale') === 'true';
  var pct = Number(box.getAttribute('data-pct')) || 20;

  // Grenzen wie die Eingabefelder im Konfigurator und dessen Fehlertext
  var MIN_H = 40, MAX_H = 117, MIN_W = 50, MAX_W = 500;

  // Kurzer Cache, damit nicht jede Produktseite die Konfigurator-Seite erneut lädt.
  // 30 Minuten: Ändert Alwin eine Formelzahl, stimmt die Produktseite spätestens danach.
  var CACHE_MS = 30 * 60 * 1000;
  var themeId = (window.Shopify && Shopify.theme && Shopify.theme.id) || '';
  var CACHE_KEY = 'ccPreisformel:' + themeId;

  var formel = null, laedt = false, geaendert = false, nutzer = false, fehlerTimer = null;

  function euro(n) { return n.toFixed(2).replace('.', ',') + ' €'; }

  function zahl(input) {
    var n = parseFloat(String(input.value).replace(',', '.'));
    return isFinite(n) ? n : NaN;
  }

  function lesen(html) {
    var attr = function (name, standard) {
      var m = html.match(new RegExp('data-' + name + '="(-?[0-9.]+)"'));
      var n = m ? parseFloat(m[1]) : NaN;
      return isFinite(n) ? n : standard;
    };
    var f = {
      area: attr('klassik-area', NaN),
      base: attr('klassik-base', 6.5),
      exp: attr('klassik-exp', 0.898),
      hcoeff: attr('klassik-hcoeff', 21),
      wcoeff: attr('klassik-wcoeff', -5),
      stufeCm: attr('height-step-cm', 60),
      stufeEur: attr('height-step-surcharge', 1.31),
      daempf: attr('height-damping', 1),
      daempfVoll: attr('height-damping-full-width', 50),
      stufe2Cm: attr('height-step2-cm', 90),
      stufe2Eur: attr('height-step2-surcharge', 0)
    };
    return f.area > 0 ? f : null;
  }

  function laden() {
    if (formel || laedt) return;
    try {
      var c = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      if (c && c.f && Date.now() - c.t < CACHE_MS) { formel = c.f; rechnen(); return; }
    } catch (e) {}
    laedt = true;
    fetch(box.getAttribute('data-config-url'), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : Promise.reject(new Error('http-' + r.status)); })
      .then(function (html) {
        var f = lesen(html);
        if (!f) return;
        formel = f;
        try { sessionStorage.setItem(CACHE_KEY, JSON.stringify({ t: Date.now(), f: f })); } catch (e) {}
        // Läuft noch die Tipp-Pause, keinen Fehlerrahmen zeigen (das macht der Timer)
        rechnen(fehlerTimer ? false : undefined);
      })
      .catch(function () {})
      .then(function () { laedt = false; });
  }

  function fehler(zeigen) {
    clearTimeout(fehlerTimer);
    fehlerTimer = null;
    fehlerEl.hidden = !zeigen;
  }

  // zeigen = false: während des Tippens nur den Preis abblenden, ohne orangen Rahmen
  function rechnen(zeigen) {
    var h = zahl(hIn), w = zahl(wIn);
    var hOk = h >= MIN_H && h <= MAX_H;
    var wOk = w >= MIN_W && w <= MAX_W;
    hIn.classList.toggle('cc-mf__in--fehler', !hOk && zeigen !== false);
    wIn.classList.toggle('cc-mf__in--fehler', !wOk && zeigen !== false);
    if (!hOk || !wOk) {
      box.classList.add('cc-mf--ungueltig');
      return false;
    }
    box.classList.remove('cc-mf--ungueltig');
    fehler(false);
    if (geaendert && nutzer) merken(h, w);
    // Unverändertes Startmaß: der serverseitige Preis stimmt bereits
    if (!geaendert) return true;
    if (!formel) {
      box.classList.add('cc-mf--laedt');
      return true;
    }
    box.classList.remove('cc-mf--laedt');
    var W = w / 100, H = h / 100;
    var stufe = h > formel.stufeCm ? formel.stufeEur * W : 0;
    // Gedaempfte Hoehe unter der Stufe und zweite Stufe, wie im Konfigurator (05.10.2026).
    if (h < formel.stufeCm) {
      var rampe = formel.daempfVoll > 50 ? Math.min(1, Math.max(0, (w - 50) / (formel.daempfVoll - 50))) : 1;
      H = (formel.stufeCm - (1 - (1 - formel.daempf) * rampe) * (formel.stufeCm - h)) / 100;
    }
    if (h > formel.stufe2Cm) stufe += formel.stufe2Eur * W;
    var raw = formel.base + formel.area * Math.pow(W * H, formel.exp) + formel.hcoeff * H + formel.wcoeff * W + stufe;
    var regulaer = Math.round(raw) + 0.90;
    if (!(regulaer > 0)) return true;
    var eigen = sale ? +(regulaer * (100 - pct) / 100).toFixed(2) : regulaer;
    jetztEl.textContent = euro(eigen);
    if (normalEl) normalEl.textContent = euro(regulaer);
    return true;
  }

  // Maß an den Konfigurator übergeben (dessen sessionStorage 'appState'), nur bei höchstens
  // einem Stück. Ein alter, von Hand gesetzter Bildausschnitt passt zum neuen Maß nicht mehr.
  function merken(h, w) {
    try {
      var st = JSON.parse(sessionStorage.getItem('appState') || 'null');
      if (Array.isArray(st) && st.length > 1) return;
      var alt = Array.isArray(st) && st[0];
      if (alt && Number(alt.height) === h && Number(alt.width) === w) return;
      sessionStorage.setItem('appState', JSON.stringify([{ height: h, width: w }]));
      var crop = JSON.parse(sessionStorage.getItem('savedCropData') || 'null');
      if (crop && crop[0]) { crop[0].manual = false; sessionStorage.setItem('savedCropData', JSON.stringify(crop)); }
    } catch (e) {}
  }

  // Beim Laden: Maß aus dem Konfigurator zeigen, wenn dort schon eines (ein Stück) gewählt ist
  (function uebernehmen() {
    try {
      var st = JSON.parse(sessionStorage.getItem('appState') || 'null');
      if (!Array.isArray(st) || st.length !== 1) return;
      var h = Number(st[0].height), w = Number(st[0].width);
      if (!(h >= MIN_H && h <= MAX_H && w >= MIN_W && w <= MAX_W)) return;
      if (h === Number(hIn.value) && w === Number(wIn.value)) return;
      hIn.value = h; wIn.value = w;
      geaendert = true;
      laden();
      rechnen();
    } catch (e) {}
  })();

  [hIn, wIn].forEach(function (input) {
    input.addEventListener('focus', laden);
    input.addEventListener('pointerdown', laden);
    input.addEventListener('input', function () {
      geaendert = true;
      nutzer = true;
      laden();
      clearTimeout(fehlerTimer);
      // Während des Tippens (z. B. „1" auf dem Weg zu „117") nicht sofort warnen
      if (!rechnen(false)) fehlerTimer = setTimeout(function () { fehlerTimer = null; if (!rechnen()) fehler(true); }, 2000);
    });
    input.addEventListener('change', function () { if (!rechnen()) fehler(true); });
    input.addEventListener('blur', function () { if (!rechnen()) fehler(true); });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') input.blur(); });
  });

  // Seit 05.10.2026 weicht die Formel beim Startmass vom Variantenpreis ab (der Backend-Preis fuer
  // Google wird spaeter nachgezogen). Darum nach der ersten echten Interaktion einmal mit der Formel
  // rechnen. Bots interagieren nicht und laden die Konfigurator-Seite deshalb nicht zusaetzlich.
  var EREIGNISSE = ['scroll', 'pointermove', 'touchstart', 'keydown'];
  function erstesMal() {
    EREIGNISSE.forEach(function (e) { window.removeEventListener(e, erstesMal, true); });
    geaendert = true;
    laden();
  }
  EREIGNISSE.forEach(function (e) { window.addEventListener(e, erstesMal, { capture: true, passive: true }); });
})();
